import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { errorAlert } from '../../../../helpers/alerts';
import { hasSameValues } from '../../../../helpers/util';
import { updatePDSSegment } from 'redux/slices/admin/productSlice';
import { updatePDSSegmentService } from 'services/admin/productService';
import SegmentProductForm from 'components/admin/SegmentProductForm';
import { setLoading } from 'redux/slices/uiSlice';

const EditSegmentPaymentServiceScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { currentPDSSegment } = useSelector((store) => store.products);
  const values = {
    name: currentPDSSegment.name,
    logo: currentPDSSegment.fd
  }

  const handlerSubmit = async (data) => {
    dispatch(setLoading(true))
    updatePDSSegmentService(currentPDSSegment.id, data)
      .then(response => {
        dispatch(updatePDSSegment({
          id: currentPDSSegment.id,
          data: response
        }))
        navigate(-1);
      })
      .catch(error => errorAlert(error))
      .finally(() => dispatch(setLoading(false)))
  }

  const validate = (data) => !hasSameValues(values, data)

  return (
    <SegmentProductForm
      title="Editar Segmento"
      goBack={() => navigate(-1)}
      defaultValues={values}
      submit={handlerSubmit}
      validate={validate}
    />
  );
}

export default EditSegmentPaymentServiceScreen